<template>
  <v-flex md12 sm12 xs12>
    <v-expansion-panel class="no-shadow card-r">
      <v-expansion-panel-content class="grey lighten-3">
        <div style="color: #2971a3" class="f-12" slot="header">School Open Days & times</div>
        <v-card class="grey lighten-3">
          <v-layout xs12 lg12>
            <v-flex xs4 class="px-2">
              <v-checkbox
                color="primary"
                label="Monday"
                value="Monday"
                v-model="opendays"
                @change="returnValues"
              ></v-checkbox>
            </v-flex>
            <v-flex xs4 class="px-2">
              <div class="f-10 pa-0 ma-0">Start Time</div>
              <v-menu
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="40"
                :return-value.sync="startTime.Monday"
                format="ampm"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  style="padding: 0px!important;margin: 0px!important;"
                  slot="activator"
                  v-model="startTime.Monday"
                  placeholder="Select time"
                  @change="fillStartFields()"
                ></v-text-field>
                <v-time-picker
                  v-if="menu1"
                  v-model="startTime.Monday"
                  format="ampm"
                  full-widths
                  @change="$refs.menu1.save(startTime.Monday)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 class="px-2">
              <div class="f-10 pa-0 ma-0">End Time</div>
              <v-menu
                ref="menu2"
                :close-on-content-click="false"
                v-model="menu2"
                :nudge-right="40"
                :return-value.sync="closeTime.Monday"
                format="ampm"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  style="padding: 0px!important;margin: 0px!important;"
                  slot="activator"
                  v-model="closeTime.Monday"
                  placeholder="Select time"
                  @change="fillCloseFields()"
                ></v-text-field>
                <v-time-picker
                  v-if="menu2"
                  v-model="closeTime.Monday"
                  format="ampm"
                  full-widths
                  @change="$refs.menu2.save(closeTime.Monday)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>

          <!-- <v-layout xs12 lg12>
          <v-flex xs12 class="px-2">
            <v-checkbox color="primary" label="select all before" value="Monday"></v-checkbox>
          </v-flex>
          </v-layout>-->
          <v-layout xs12 lg12>
            <v-flex xs4 class="px-2">
              <v-checkbox
                color="primary"
                label="Tuesday"
                value="Tuesday"
                v-model="opendays"
                @change="returnValues"
              ></v-checkbox>
            </v-flex>
            <v-flex xs4 class="px-2">
              <div class="f-10 pa-0 ma-0 mt-3"></div>
              <v-menu
                ref="menu3"
                :close-on-content-click="false"
                v-model="menu3"
                :nudge-right="40"
                :return-value.sync="startTime.Tuesday"
                format="ampm"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  style="padding: 0px!important;margin: 0px!important;"
                  slot="activator"
                  v-model="startTime.Tuesday"
                  placeholder="Select time"
                  @change="returnValues()"
                ></v-text-field>
                <v-time-picker
                  v-if="menu3"
                  v-model="startTime.Tuesday"
                  format="ampm"
                  full-widths
                  @change="$refs.menu3.save(startTime.Tuesday)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 class="px-2">
              <div class="f-10 pa-0 ma-0 mt-3"></div>
              <v-menu
                ref="menu4"
                :close-on-content-click="false"
                v-model="menu4"
                :nudge-right="40"
                :return-value.sync="closeTime.Tuesday"
                format="ampm"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  style="padding: 0px!important;margin: 0px!important;"
                  slot="activator"
                  v-model="closeTime.Tuesday"
                  placeholder="Select time"
                  @change="returnValues()"
                ></v-text-field>
                <v-time-picker
                  v-if="menu4"
                  v-model="closeTime.Tuesday"
                  format="ampm"
                  full-widths
                  @change="$refs.menu4.save(closeTime.Tuesday)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout xs12 lg12>
            <v-flex xs4 class="px-2">
              <v-checkbox
                color="primary"
                label="Wednesday"
                value="Wednesday"
                v-model="opendays"
                @change="returnValues"
              ></v-checkbox>
            </v-flex>
            <v-flex xs4 class="px-2">
              <div class="f-10 pa-0 ma-0 mt-3"></div>
              <v-menu
                ref="menu5"
                :close-on-content-click="false"
                v-model="menu5"
                :nudge-right="40"
                :return-value.sync="startTime.Wednesday"
                format="ampm"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  style="padding: 0px!important;margin: 0px!important;"
                  slot="activator"
                  v-model="startTime.Wednesday"
                  placeholder="Select time"
                  @change="returnValues()"
                ></v-text-field>
                <v-time-picker
                  v-if="menu5"
                  v-model="startTime.Wednesday"
                  format="ampm"
                  full-widths
                  @change="$refs.menu5.save(startTime.Wednesday)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 class="px-2">
              <div class="f-10 pa-0 ma-0 mt-3"></div>
              <v-menu
                ref="menu6"
                :close-on-content-click="false"
                v-model="menu6"
                :nudge-right="40"
                :return-value.sync="closeTime.Wednesday"
                format="ampm"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  style="padding: 0px!important;margin: 0px!important;"
                  slot="activator"
                  v-model="closeTime.Wednesday"
                  placeholder="Select time"
                  @change="returnValues()"
                ></v-text-field>
                <v-time-picker
                  v-if="menu6"
                  v-model="closeTime.Wednesday"
                  format="ampm"
                  full-widths
                  @change="$refs.menu6.save(closeTime.Wednesday)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout xs12 lg12>
            <v-flex xs4 class="px-2">
              <v-checkbox
                color="primary"
                label="Thursday"
                value="Thursday"
                v-model="opendays"
                @change="returnValues"
              ></v-checkbox>
            </v-flex>
            <v-flex xs4 class="px-2">
              <div class="f-10 pa-0 ma-0 mt-3"></div>
              <v-menu
                ref="menu7"
                :close-on-content-click="false"
                v-model="menu7"
                :nudge-right="40"
                :return-value.sync="startTime.Thursday"
                format="ampm"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  style="padding: 0px!important;margin: 0px!important;"
                  slot="activator"
                  v-model="startTime.Thursday"
                  placeholder="Select time"
                  @change="returnValues()"
                ></v-text-field>
                <v-time-picker
                  v-if="menu7"
                  v-model="startTime.Thursday"
                  format="ampm"
                  full-widths
                  @change="$refs.menu7.save(startTime.Thursday)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 class="px-2">
              <div class="f-10 pa-0 ma-0 mt-3"></div>
              <v-menu
                ref="menu8"
                :close-on-content-click="false"
                v-model="menu8"
                :nudge-right="40"
                :return-value.sync="closeTime.Thursday"
                format="ampm"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  style="padding: 0px!important;margin: 0px!important;"
                  slot="activator"
                  v-model="closeTime.Thursday"
                  placeholder="Select time"
                  @change="returnValues()"
                ></v-text-field>
                <v-time-picker
                  v-if="menu8"
                  v-model="closeTime.Thursday"
                  format="ampm"
                  full-widths
                  @change="$refs.menu8.save(closeTime.Thursday)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout xs12 lg12>
            <v-flex xs4 class="px-2">
              <v-checkbox
                color="primary"
                label="Friday"
                value="Friday"
                v-model="opendays"
                @change="returnValues"
              ></v-checkbox>
            </v-flex>
            <v-flex xs4 class="px-2">
              <div class="f-10 pa-0 ma-0 mt-3"></div>
              <v-menu
                ref="menu9"
                :close-on-content-click="false"
                v-model="menu9"
                :nudge-right="40"
                :return-value.sync="startTime.Friday"
                format="ampm"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  style="padding: 0px!important;margin: 0px!important;"
                  slot="activator"
                  v-model="startTime.Friday"
                  placeholder="Select time"
                  @change="returnValues()"
                ></v-text-field>
                <v-time-picker
                  v-if="menu9"
                  v-model="startTime.Friday"
                  format="ampm"
                  full-widths
                  @change="$refs.menu9.save(startTime.Friday)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 class="px-2">
              <div class="f-10 pa-0 ma-0 mt-3"></div>
              <v-menu
                ref="menu10"
                :close-on-content-click="false"
                v-model="menu10"
                :nudge-right="40"
                :return-value.sync="closeTime.Friday"
                format="ampm"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  style="padding: 0px!important;margin: 0px!important;"
                  slot="activator"
                  v-model="closeTime.Friday"
                  placeholder="Select time"
                  @change="returnValues()"
                ></v-text-field>
                <v-time-picker
                  v-if="menu10"
                  v-model="closeTime.Friday"
                  format="ampm"
                  full-widths
                  @change="$refs.menu10.save(closeTime.Friday)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout xs12 lg12>
            <v-flex xs4 class="px-2">
              <v-checkbox
                color="primary"
                label="Saturday"
                value="Saturday"
                v-model="opendays"
                @change="returnValues"
              ></v-checkbox>
            </v-flex>
            <v-flex xs4 class="px-2">
              <div class="f-10 pa-0 ma-0 mt-3"></div>
              <v-menu
                ref="menu11"
                :close-on-content-click="false"
                v-model="menu11"
                :nudge-right="40"
                :return-value.sync="startTime.Saturday"
                format="ampm"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  style="padding: 0px!important;margin: 0px!important;"
                  slot="activator"
                  v-model="startTime.Saturday"
                  placeholder="Select time"
                  @change="returnValues()"
                ></v-text-field>
                <v-time-picker
                  v-if="menu11"
                  v-model="startTime.Saturday"
                  format="ampm"
                  full-widths
                  @change="$refs.menu11.save(startTime.Saturday)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 class="px-2">
              <div class="f-10 pa-0 ma-0 mt-3"></div>
              <v-menu
                ref="menu12"
                :close-on-content-click="false"
                v-model="menu12"
                :nudge-right="40"
                :return-value.sync="closeTime.Saturday"
                format="ampm"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  style="padding: 0px!important;margin: 0px!important;"
                  slot="activator"
                  v-model="closeTime.Saturday"
                  placeholder="Select time"
                  @change="returnValues()"
                ></v-text-field>
                <v-time-picker
                  v-if="menu12"
                  v-model="closeTime.Saturday"
                  format="ampm"
                  full-widths
                  @change="$refs.menu12.save(closeTime.Saturday)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout xs12 lg12>
            <v-flex xs4 class="px-2">
              <v-checkbox
                color="primary"
                label="Sunday"
                value="Sunday"
                v-model="opendays"
                @change="returnValues"
              ></v-checkbox>
            </v-flex>
            <v-flex xs4 class="px-2">
              <div class="f-10 pa-0 ma-0 mt-3"></div>
              <v-menu
                ref="menu13"
                :close-on-content-click="false"
                v-model="menu13"
                :nudge-right="40"
                :return-value.sync="startTime.Sunday"
                format="ampm"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  style="padding: 0px!important;margin: 0px!important;"
                  slot="activator"
                  v-model="startTime.Sunday"
                  placeholder="Select time"
                  @change="returnValues()"
                ></v-text-field>
                <v-time-picker
                  v-if="menu13"
                  v-model="startTime.Sunday"
                  format="ampm"
                  full-widths
                  @change="$refs.menu13.save(startTime.Sunday)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 class="px-2">
              <div class="f-10 pa-0 ma-0 mt-3"></div>
              <v-menu
                ref="menu14"
                :close-on-content-click="false"
                v-model="menu14"
                :nudge-right="40"
                :return-value.sync="closeTime.Sunday"
                format="ampm"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  style="padding: 0px!important;margin: 0px!important;"
                  slot="activator"
                  v-model="closeTime.Sunday"
                  placeholder="Select time"
                  @change="returnValues()"
                ></v-text-field>
                <v-time-picker
                  v-if="menu14"
                  v-model="closeTime.Sunday"
                  format="ampm"
                  full-widths
                  @change="$refs.menu14.save(closeTime.Sunday)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-flex>
</template>
<script>
/* eslint-disable */
export default {
  data: () => ({
    time: null,
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu10: false,
    menu11: false,
    menu12: false,
    menu13: false,
    menu14: false,
    monday: "",
    tuesday: "",
    wednesday: "",
    thursday: "",
    friday: "",
    saturday: "",
    sunday: "",
    opendays: [],
    startTime: {
      Monday: "",
      Tuesday: "",
      Wednesday: "",
      Thursday: "",
      Friday: "",
      Saturday: "",
      Sunday: ""
    },
    closeTime: {
      Monday: "",
      Tuesday: "",
      Wednesday: "",
      Thursday: "",
      Friday: "",
      Saturday: "",
      Sunday: ""
    },
    fillFields: [false, false]
  }),
  created(){
    // this.startTime.Monday = Store.state.startTime[0];
    // this.startTime.Tuesday = Store.state.startTime[1];
    // this.startTime.Wednesday = Store.state.startTime[2];
    // this.startTime.Thursday = Store.state.startTime[3];
    // this.startTime.Friday = Store.state.startTime[4];
    // this.startTime.Saturday = Store.state.startTime[5];
    // this.startTime.Sunday = Store.state.startTime[6];
  },
  methods: {
    fillStartFields() {
      if (this.fillFields[0] == false) {
        this.startTime.Tuesday = this.startTime.Monday;
        this.startTime.Wednesday = this.startTime.Monday;
        this.startTime.Thursday = this.startTime.Monday;
        this.startTime.Friday = this.startTime.Monday;
        this.startTime.Saturday = this.startTime.Monday;
        this.startTime.Sunday = this.startTime.Monday;
        this.fillFields[0] = true;
      }
      this.returnValues();
    },
    fillCloseFields() {
      if (this.fillFields[1] == false) {
        this.closeTime.Tuesday = this.closeTime.Monday;
        this.closeTime.Wednesday = this.closeTime.Monday;
        this.closeTime.Thursday = this.closeTime.Monday;
        this.closeTime.Friday = this.closeTime.Monday;
        this.closeTime.Saturday = this.closeTime.Monday;
        this.closeTime.Sunday = this.closeTime.Monday;
        this.fillFields[1] = true;
      }
      this.returnValues();
    },
    returnValues() {
      var Data = {
        Days: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        startTime: [null, null, null, null, null, null, null],
        closeTime: [null, null, null, null, null, null, null]
      };
      for (var i = 0; i < 7; i++) {
        var Day = this.opendays[i];
        switch (Day) {
          case "Monday":
            Data.startTime[0] = this.startTime.Monday;
            Data.closeTime[0] = this.closeTime.Monday;
            break;
          case "Tuesday":
            Data.startTime[1] = this.startTime.Tuesday;
            Data.closeTime[1] = this.closeTime.Tuesday;
            break;
          case "Wednesday":
            Data.startTime[2] = this.startTime.Wednesday;
            Data.closeTime[2] = this.closeTime.Wednesday;
            break;
          case "Thursday":
            Data.startTime[3] = this.startTime.Thursday;
            Data.closeTime[3] = this.closeTime.Thursday;
            break;
          case "Friday":
            Data.startTime[4] = this.startTime.Friday;
            Data.closeTime[4] = this.closeTime.Friday;
            break;
          case "Saturday":
            Data.startTime[5] = this.startTime.Saturday;
            Data.closeTime[5] = this.closeTime.Saturday;
            break;
          case "Sunday":
            Data.startTime[6] = this.startTime.Sunday;
            Data.closeTime[6] = this.closeTime.Sunday;
            break;
        }
      }
      this.$emit("setDaysAndTime", Data);
    }
  },
  components: {}
};
</script>
<style>
.v-expansion-panel__header {
  padding: 0px !important;
  margin: 10px 0px 10px 0px !important;
}
.theme--light.v-expansion-panel
  .v-expansion-panel__container
  .v-expansion-panel__header
  .v-expansion-panel__header__icon
  .v-icon {
  font-size: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/pages/customers/OpenDays.vue